module.exports = "<div style=\"\">\r\n    <img v-lazy=\"fnjiImage(image)\" :key=\"image\" v-if=\"images.length == 1\" width=\"100%\">\r\n    <image-slick v-else-if=\"images.length > 1\" :images=\"images\" :options=\"options\"></image-slick>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail/component/images-box.html
// module id = 264
// module chunks = 0